<template>
	<div id="nav">
		<!--router-link
			v-for="entry in this.entries"
			:key="entry.to"
			:to="{ name: entry.to }"
			tag="a"
			active-class="active-link"
			class="btn header-el"
			>{{ entry.label }}</router-link
		-->

		<div id="header-el-wrapper">
			<router-link
				:to="{ name: 'Home' }"
				tag="a"
				active-class="active-link"
				class="btn header-el"
				>Home</router-link
			>
			<router-link
				:to="{ name: 'Steam' }"
				tag="a"
				active-class="active-link"
				class="btn header-el"
				>Steam</router-link
			>
			<router-link
				:to="{ name: 'About' }"
				tag="a"
				active-class="active-link"
				class="btn header-el"
				>About</router-link
			>

			<span class="header-el"></span>

			<router-link
				:to="{ name: 'Chat' }"
				tag="a"
				active-class="active-link"
				class="btn header-el"
				>Chat</router-link
			>

			<router-link
				:to="{ name: 'Minecraft' }"
				tag="a"
				active-class="active-link"
				class="btn header-el"
				>Minecraft</router-link
			>
			<router-link
				:to="{ name: 'Share' }"
				tag="a"
				active-class="active-link"
				class="btn header-el"
				>Share</router-link
			>

			<span class="header-el"></span>

			<router-link :to="{ name: 'Login' }" tag="button" class="btn header-el">
				<span v-if="!$store.getters.isLoggedIn">Login</span>
				<span v-else>{{ $store.getters.username }}</span>
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HeaderComponent.vue',
	data: function() {
		return {
			entries: [
				{
					to: 'Home',
					label: 'Home'
				},
				{
					to: 'Steam',
					label: 'Steam'
				},
				{
					to: 'About',
					label: 'About'
				},
				{
					to: 'Chat',
					label: 'Chat'
				},
				{
					to: 'Minecraft',
					label: 'Minecraft'
				},
				{
					to: 'Share',
					label: 'Share'
				}
			],
			externalLinks: [
				{
					name: 'Cloud',
					path: 'https://cloud.zipixx.com'
				}
			]
		};
	}
};
</script>

<style lang="scss" scoped>
#nav {
	padding: 5px 0;
	border-bottom: 1px solid #aaa;
	background-color: #222;
	opacity: 0.9;

	#header-el-wrapper {
		width: fit-content;
		margin: 0 auto;
		display: grid;
		grid-auto-columns: minmax(60px, 95px);
	}
	.header-el {
		color: #fff;
		grid-row: 1;
	}
	/* default set to active-link in html to prevent wrong triggering / multi-active */
	.router-link-exact-active,
	.router-link-active {
		background-color: #444;
	}
}
</style>
